import { render, staticRenderFns } from "./customer-reservations.vue?vue&type=template&id=f0c3b976&scoped=true&"
import script from "./customer-reservations.vue?vue&type=script&lang=js&"
export * from "./customer-reservations.vue?vue&type=script&lang=js&"
import style0 from "./customer-reservations.vue?vue&type=style&index=0&id=f0c3b976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c3b976",
  null
  
)

export default component.exports